import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { CopyButton } from '../../../../ui/copy-button';

type Props = {
  value: string;
};

export const TransactionHashCellRenderer = ({ value }: Props) => {
  const shortened = `${value?.slice(0, 12)}...`;
  const { chain } = useParams<{ chain: string }>();

  if (!chain) return null;

  return (
    <div className="flex items-center gap-2">
      <Link
        to={`/${chain}/transaction/${value}`}
        className="inline-block w-[115px] text-[#0584C3] hover:underline"
        title={value}
      >
        {shortened}
      </Link>
      <CopyButton
        text={value}
        className="flex h-5 w-5 items-center justify-center"
        iconSize={14}
      />
    </div>
  );
};
